export default __webpack_public_path__ + "static/International-7a192423be6542057143d2fcf02f45a6.jpg";